import React, { useState, useRef, useEffect } from 'react'
import "../styles/about.css";
import Aos from 'aos';
import 'aos/dist/aos.css';
import { FaCheck, FaCss3, FaFigma, FaHtml5, FaJs, FaLaravel, FaPhp, FaReact, FaWordpress } from 'react-icons/fa';
import { SiFlutter } from 'react-icons/si';
 

const About = () => {
  // let [tabToggle, setTabToggle] = useState(false);
  const [currentTab, setCurrentTab] = useState(1);
  const [expHead, setExpHead] = useState(10);
  const read = useRef();
  const readmore = useRef();

  const tabClicked = (id) =>{
    setCurrentTab(id);
  }

  const expHeadTabbed = (index) =>{
    setExpHead(index)
  }

  
    useEffect(() =>{
      Aos.init({
      duration: 1000, 
      easing: 'ease-in-out', 
      once: false,  
      offset: 100, 
      });
    }, [])
 

 

  // const readMore = () =>{
  //   if(read.current.style.display === "none"){
  //     read.current.style.display = "block";
  //     readmore.current.innerHTML = "Read Less";
  //   }else{
  //     read.current.style.display = "none";
  //     readmore.current.innerHTML = "Read More";
  //   }
  // }
    return (
    <div id='about'>
      <div className='about-text'>
        <h1  data-aos ='fade-up'>My Story</h1>
        <p className='sub-head' data-aos ='fade-up'>My journey in tech and beyond</p>
        {/* <div className='history'>
          <p className='p1'>
          I am full-stack web and mobile app developer with keen passion for building beautiful and user-friendly software. 
          I am a very quick learner and team player. In my free time, I enjoy listening to music, 
          I have always had love for good music and find that it helps to relax and inspire me in the work.            
          </p>
          
          <p className='p2' ref={read}>
          I studied BA Education (Psychology and Information Studies), and wanted to work as a Clinical Psychologist, 
          but decided to gain some computing skills to complement what I already learnt in Information Studies.   
            <br/> <br/>
          Though challenging at first, I embraced the learning curve and discovered that coding was something 
          I was truly passionate about. Now, I’m excited to build intuitive, 
          impactful projects and continue growing as a developer.                          
          </p> 
         
               <button className='read-more' onClick={readMore} ref={readmore}>Read More</button>     
        </div> */}

        <div className='history'>
          
          <p className='p1' data-aos="fade-up">
            <input type='checkbox' id='textbox'/>
          {/* I am creative web and mobile app developer with keen passion for building beautiful and user-friendly software. 
          I am a very quick learner and team player. In my free time, I enjoy listening to music, 
          I have always had love for good music and find that it helps to relax and inspire me in the work.  */}

          I'm a creative web and mobile app developer with a passion for building striking, 
          user-first digital experiences. Agile-minded and tech-savvy, I thrive in environments where design meets function.
          When I'm not crafting responsive interfaces, I'm usually listening to good music. 
          This is my go-to space for creative inspiration.
         
          <br/><br/>
          <div className='hidden-text'>
          I studied BA Education (Psychology and Information Studies), and wanted to work as a Clinical Psychologist, 
          but decided to gain some computing skills to complement what I already learnt in Information Studies.  
          However, I found software development fascinating and decided to stick with it.
          The logical problem-solving aspects and the ability to create tangible solutions
           drew me away from my original career path in psychology. 
            <br/> <br/>
          Though challenging at first, I embraced the learning curve and discovered that coding was something 
          I was truly passionate about. Now, I’m excited to build intuitive, 
          impactful projects and continue growing as a developer.
          I'm open to Job opportunities where I can contribute, learn and grow.
          If you have a good opportunity that matches my skills and experience then don't hesitate to contact me.
          <br/><br/>
          <label for="textbox" className='readless'>Read less</label>  
          </div>    
          <label for="textbox" className='readmore'>Read more</label>       
           </p>
           
        </div>

        <div className='about-tabs' data-aos = 'fade-up'>
          <ul>
            <li className={currentTab == 1? "tab active" : "tab"} onClick={()=>tabClicked(1)}>Tech Stack</li>
            <li className={currentTab == 2? "tab active" : "tab"} onClick={()=>tabClicked(2)}>Experience</li>
            <li className={currentTab == 3? "tab active" : "tab"} onClick={()=>tabClicked(3)}>Highlights</li>
          </ul>
          <div className='tab-contents'>
            <div className={currentTab === 1? "content active" : "content"}>
              <p className='stack'>Tooling</p>
              <div className='skills' data-aos='fade-up'>
                {/* <div className='skill-img'><img src={`${process.env.PUBLIC_URL}/images/php.png`} /></div>
                <div className='skill-img'><img src={`${process.env.PUBLIC_URL}/images/javascript.png`} /></div>
                <div className='skill-img'><img src={`${process.env.PUBLIC_URL}/images/flutter.png`} /></div>
                <div className='skill-img'><img src={`${process.env.PUBLIC_URL}/images/react.png`} /></div>
                <div className='skill-img'> <img src={`${process.env.PUBLIC_URL}/images/laravel.png`} /></div>
                <div className='skill-img'> <img src={`${process.env.PUBLIC_URL}/images/figma.png`} /></div>
                <div className='skill-img'><img src={`${process.env.PUBLIC_URL}/images/wordpress.png`} /></div>
                <div className='skill-img'> <img src={`${process.env.PUBLIC_URL}/images/html.png`} /></div>
                <div className='skill-img'> <img src={`${process.env.PUBLIC_URL}/images/css.png`} /></div> */}

                <div>
                  <FaPhp className="tech-icon"/>
                  <p>PHP</p>
                </div>
                <div>
                  <FaLaravel className="tech-icon"/>
                  <p>Laravel</p>
                </div>
                <div>
                  <FaJs className="tech-icon"/>
                  <p>JavaScript</p>
                </div>
                <div>
                  <FaReact className="tech-icon"/>
                  <p>React Js</p>
                </div>
                <div>
                  <SiFlutter className="tech-icon"/>
                  <p>Flutter</p>
                </div>
                <div>
                  <FaFigma className="tech-icon"/>
                  <p>Figma</p>
                </div>
                <div>
                  <FaWordpress className="tech-icon"/>
                  <p>WordPress</p>
                </div>
                <div>
                  <FaCss3 className="tech-icon"/>
                  <p>CSS</p>
                </div>
                <div>
                  <FaHtml5 className="tech-icon"/>
                  <p>HTML</p>
                </div>
              </div>
            </div>
            
            <div  className={currentTab === 2? "content active": "content"}>
              <p className='stack'>Work Experience</p><br/>
            <div className={expHead === 10? 'exp-head active' : 'exp-head'} onClick={() => expHeadTabbed(10)}>
              <h6> Developer & Designer(Part-Time) @ PEN NETWORK</h6>
              <h6>March 2025 - Present</h6>
            </div>  
             <div className={expHead == 10? 'exp-content show' : 'exp-content'}>
            <div className='exp-sub-head'>Developer & Designer(March 2025 - Present)</div>  
            <p> 
                ▪ Designed and developed websites and mobile applications as part of a collaborative team. <br/>
                ▪ Contributed to successful completion of several websites for clients. <br/>
                ▪ Currently working on mobile apps projects, focusing on both design and development tasks. <br/>
                ▪ Worked closely with teams to brainstorm ideas, troubleshoot issues, and deliver high-quality products.
                </p>
            </div>
            
            <div className={expHead === 20? 'exp-head active' : 'exp-head'} onClick={() => expHeadTabbed(20)}>
              <h6>Developer & Data Analyst Trainee(NSS) @ NSA TECH LAB</h6>
              <h6>October 2024 - September 2025</h6>
            </div>
            <div className={expHead == 20? 'exp-content show' : 'exp-content'}>
                <div className='exp-sub-head'>Software Developer & Data Analysis Trainee(October 2024 - Present)</div> 
            <p>
            ▪ Undergone a comprehensive training in software development, designing and data analysis.  <br/>
            ▪ Gained hands-on experience in data analysis, including data cleaning, visualization, and interpretation.  <br/>
            ▪ Contributed to the design and development of a mobile application as the final project for the training. <br/>
            ▪ Enhanced problem-solving skills by learning and applying best practices in coding and version control.
            </p>
            </div>
             
             
             <div className={expHead === 30? 'exp-head active' : 'exp-head'} onClick={() => expHeadTabbed(30)}>
              <h6>PHP Developer(Intern) @ PENTATECH IT SOLUTIONS</h6>
              <h6>May - June 2023</h6>
            </div>
             <div className={expHead == 30? 'exp-content show' : 'exp-content'}>
            <div className='exp-sub-head'>PHP Developer(May 2024 - June 2023).</div>  
            <p>
            ▪ Created a fully functional PHP and MySQL CRUD application. <br/>
            ▪ Developed an SMTP-based email sender in PHP for automated and bulk emailing with security measures. <br/>
            ▪ Implemented a PDF generation feature using DOMPDF PHP library. <br/>
            ▪ Built a secure user authentication system with features like registration, login, and password management. 
            </p>
            </div>
            </div>
            
            <div className={currentTab === 3? "content active" : "content"}>
             {/* <h3> University of Ghana Computer Science Department </h3>
            📝 Mobile Application Development (Flutter) <br/>
            📝 Web Programming */}
             <p className='stack'>Skill Highlights</p><br/>
            <span><FaCheck />  Teamplayer</span> <br/>
            <span><FaCheck />  Problem-Solving</span> <br/>
            <span><FaCheck />  Self-Learning</span> <br/>
            <span><FaCheck />  Data Entry</span> <br/>
            <span><FaCheck />  Resilience</span> <br/>
            <span><FaCheck />  Innovative</span> <br/>
            <span><FaCheck />  Critical-Thinking</span> <br/>
            <span><FaCheck />  Service-focused</span> <br/>
            <span><FaCheck />  Creative Design</span> <br/>
            <span><FaCheck />  Result Oriented</span> <br/>
             
            </div>
          </div>
        </div>
      </div>
      <div className='about-img' data-aos="fade-up">
        {/* <img src='images/img_avatar.png'/> */}
        {/* <img src='images/image4.jpg'/> */}
        <img src={`${process.env.PUBLIC_URL}/images/ray.png`} />

      </div>
    </div>
  )
}

export default About